import React from 'react'
import Swiper from 'react-id-swiper'
import PropTypes from 'prop-types'
import ResponsiveImage from 'components/images/responsive-image'
import env from 'config/env'

class ImagesSlider extends React.PureComponent {
  renderProductImage(image) {
    let src = image.url || image.image

    if (src && typeof src === 'string' && src.charAt(0) === '/') {
      src = src.substr(1, src.length - 1)
    }

    src = `${env.IMG_HOST}${src}`

    return (
      <ResponsiveImage
        key={src}
        imgRatio={1.33}
        src={src}
        phone="80vw"
        tablet="15vw"
        laptop="15vw"
        desktop="15vw"
        bigDesktop="15vw"
      />
    )
  }

  render() {
    const { images, sliderOptions } = this.props

    return (
      <Swiper {...sliderOptions}>{images.map(this.renderProductImage)}</Swiper>
    )
  }
}

ImagesSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sliderOptions: PropTypes.shape({}).isRequired,
}

export default ImagesSlider
